require('../css/index.css');
$(function(){
    var news = {
        list:[
            {
                id:1,
                time:1505577600,
                img:'http://sz1-test-sep-static.oss-cn-shenzhen.aliyuncs.com/hnimgs/1.jpg',
                title:'海纳影业携手腾讯开展深度合作 《西行纪》等经典作品将登荧幕',
                text:'2017年9月17日，海纳影业出席了在北京举行的腾讯影业“同心·致远”发布会。发布会上，海纳影业正式宣布与腾讯影业达成战略合作关系，将成为腾讯影业未来的核心战略合作伙伴，并公布了双方后续合作开发制作的影视剧项目，诸如：《守夜者》、《西行纪》、《死人经》、《新金粉世家》、《冠军之光》等。',
            },
        ]
    };
    var vm = new Vue({
        el:'#textCent',
        data:{
            itmes:[],
        },
        //监听
        watch: {},

        //计算属性
        computed: {},

        //事件处理
        methods: {
            //文字处理
            centText:function(txt){
                if(txt.length>=88){
                    return txt.substring(0,88)+'...'
                }else{
                    return txt;
                }
            },

            //时间处理
            getTimeDay:function(nS,d){
                var s = nS+'';
                var time = 0;
                if(s.length<=10){
                    s = parseInt(s+'000');
                }
                var data = new Date(s)
                if(d=='day'){
                    time = data.getUTCMonth()+1+'月';
                }
                if(d=='months'){
                    time = data.getDate();
                }
                console.log(time)
                return time;
            },

            //初始化请求
            getDataInit:function(n){
                var _this = this;
                _this.itmes = news.list;
                console.log('开始')
                console.log(this.itmes)
            }
        },

        //实例加载完成后
        created:function(){
            this.getDataInit(0)
        },

        mounted:function(){}
    })
})


//////////////////
// WEBPACK FOOTER
// ./src/js/news.js
// module id = 3
// module chunks = 0